import { useSelector } from 'react-redux';
import React, { useEffect, useState } from 'react';

import { Box, Typography } from '@mui/material';

import { isLoading } from 'hooks/requests';
import { useCompanyService } from 'store/services/company.service';
import { useInventoryService } from 'store/services/inventory.service';
import { Modal, Button, CircleLoading, EmailAccordion } from 'shared';

const EmailSourceModal = ({ transaction, showEmailSourceModal, setShowEmailSourceModal, emailIds }) => {
    const companyData = useSelector((state) => state.company.data);
    const { getCompanyEmails } = useCompanyService();
    const { getEmailById } = useInventoryService();
    const [emails, setEmails] = useState(null);

    const handleGetInventorySource = async () => {
        try {
            if (emailIds) {
                const response = await getEmailById(companyData?.id, emailIds);
                setEmails(response.data);
            } else if (transaction) {
                const response = await getCompanyEmails(
                    companyData?.id,
                    transaction?.amount,
                    transaction?.date,
                );
                setEmails(response.data);
            }
        } catch (error) {
            console.error(error);
            setEmails([]);
        }
    };

    useEffect(() => {
        if (companyData && showEmailSourceModal) {
            handleGetInventorySource();
        }
    }, [companyData, showEmailSourceModal, emailIds, transaction]);

    return (
        <Modal
            fullWidth={true}
            open={showEmailSourceModal}
            title="Inventory Source"
            handleClose={() => setShowEmailSourceModal(false)}
            customWidth="75%"
            showFooter
            footer={
                <Box>
                    <Button text="Cancel" onClick={() => setShowEmailSourceModal(false)} />
                </Box>
            }
        >
            {isLoading() && !emails ? (
                <CircleLoading />
            ) : !emails?.length ? (
                <Box display="flex" alignItems="center" marginBottom="10px" justifyContent="center">
                    <Typography>No source email found</Typography>
                </Box>
            ) : (
                <EmailAccordion emails={emails} />
            )}
        </Modal>
    );
};

export default EmailSourceModal;
